import React from 'react';
import ReactPlayer from 'react-player';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    color: '#3C4858',
  },
  text: {
    textAlign: 'center',
  },
  link: {
    fontSize: 22,
    fontWeight: 'bold',
    margin: '10px auto 20px',
    textAlign: 'center',
  },
  linkText: {},
}));

const TeachingVideo = () => {
  const classes = useStyles();
  return (
    <Grid id="video" container spacing={3} justify="center" id="video">
      <Grid item xs={12} sm={12} md={10}>
        <div className={classes.root}>
          <h2 className={classes.title}>Навчально-методичні матеріали</h2>
          <p className={classes.text}>
            Розроблено навчально-методичні матеріали у формі відеороликів з питань використання Програмного комплексу
            «Інтегрована інформаційна система «Соціальна громада».
          </p>
          <a className={classes.link} href="https://www.youtube.com/playlist?list=PLCZVFyAjYB-ky9UkGw3cQWnVyd7I87rSd">
            <span className={classes.linkText}>Пряме посилання на навчально-методичні матеріали</span>
          </a>
          <ReactPlayer url="https://www.youtube.com/watch?v=U9R49io8xPI&list=PLCZVFyAjYB-ky9UkGw3cQWnVyd7I87rSd" />
        </div>
      </Grid>
    </Grid>
  );
};

export default TeachingVideo;
